import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import IndependentPaymentStages from '../components/layout/IndependentPaymentStages';
import GroupPaymentStages from '../components/layout/GroupPaymentStages';
import PaymentTemplates from '../components/layout/PaymentTemplates';

/**
 * Payment schedule content for a single view. Independent / Group / Templates
 * sit on the right of the same pricing bar as the main pills (justify-between).
 */
const PaymentStagesDetails = ({ activeView = 'Independent', projectId: projectIdProp }) => {
  const userId = Cookies.get('userId');
  const { id: projectIdFromRoute } = useParams();
  const projectId = projectIdProp ?? projectIdFromRoute;

  useEffect(() => {
    mixpanel.track('Payment Stages Details Viewed', {
      user_id: userId,
      view: activeView,
      timestamp: new Date().toISOString()
    });
  }, [userId, activeView]);

  return (
    <div
      className={`transition-all duration-300 ease-in-out w-full flex flex-col pl-5 pr-5 bg-gray-100 overflow-hidden`}>
      <div className="mt-6">
        {activeView === 'Independent' ? (
          <IndependentPaymentStages projectId={projectId} />
        ) : activeView === 'Group' ? (
          <GroupPaymentStages projectId={projectId} />
        ) : (
          <PaymentTemplates projectId={projectId} />
        )}
      </div>
    </div>
  );
};

export default PaymentStagesDetails;
